import * as zod from 'zod';

import { Conditional } from '../../types';

export default zod.object({
  condition: Conditional,
});
